'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import ScrollContainer from './ScrollContainer';
import SuccessFailIndicator from './SuccessFailIndicator';

function AbsoluteFixedContainingBlocks() {
  const [isOverflowing, setIsOverflowing] = React.useState(false);
  const targetRef = React.useRef<HTMLDivElement>(null);

  return (
    <Wrapper>
      <Column>
        <Heading>position: absolute</Heading>
        <ScrollContainer variant="absolute" />
        <SuccessFailIndicator isSuccessful={true}>
          No overflow detected
        </SuccessFailIndicator>
      </Column>
      <Column>
        <Heading>position: fixed</Heading>
        <ScrollContainer
          variant="fixed"
          targetRef={targetRef}
          onScroll={(event) => {
            const target = targetRef.current;
            const container = event.currentTarget.firstElementChild;

            if (!target || !(container instanceof HTMLElement)) {
              return;
            }

            const targetRect = target.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();

            const isOverflowing =
              targetRect.top < containerRect.top ||
              targetRect.bottom > containerRect.bottom ||
              targetRect.left < containerRect.left ||
              targetRect.right > containerRect.right;

            setIsOverflowing(isOverflowing);
          }}
        />
        <SuccessFailIndicator isSuccessful={!isOverflowing}>
          {isOverflowing
            ? 'Overflow detected'
            : 'No overflow detected'}
        </SuccessFailIndicator>
      </Column>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 32px;
  padding: 32px;
  background: var(--color-warning-300);
  border-radius: 8px;
  margin-bottom: 48px;

  @media (max-width: 43rem) {
    flex-direction: column;
    gap: 24px;
    padding: 16px;
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Heading = styled.div`
  font-family: var(--font-family-mono);
  text-align: center;
  font-weight: var(--font-weight-bold);
  font-size: 1rem;
`;

export default AbsoluteFixedContainingBlocks;
